<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">How would you rate {{prospect.contact.firstName}} as a prospect?</h3>
    <p class="ut-mb-6 ut-text-neutral-400 ut-text-xs">We use your feedback to improve the prospects we send to you</p>
    <div class="ut-w-64 ut-ml-0 ut-text-xxs ut-mb-4">
      <ul class="ut-flex ut-text-neutral-100 ut-justify-between ut-mb-3">
        <li v-for="rating in answers"
          :key="rating" :value="rating"
          class="hover:ut-text-green-400 ut-cursor-pointer ut-m-0"
          @mouseover="selectedAnswer = rating"
          @mouseleave="selectedAnswer = 0"
          @click="confirm(selectedAnswer)"
          v-gaEvent="{ category: gacategory, action: `Agent feedback ${rating} star` }"
          v-bind:class="{ 'ut-text-green-400': rating < activeStar }">
            <svg-loader name="icon-star"
                :width="24"
                class="ut-m1-0" />
        </li>
      </ul>
      <span class="ut-float-left ut-text-neutral-200">Very bad</span>
      <span class="ut-float-right ut-text-neutral-200">Very good</span>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';

export default {
  name: 'ProspectQualityQuesRating',
  components: {
    SvgLoader,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: 0,
      answers: [1, 2, 3, 4, 5],
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    activeStar() {
      return this.selectedAnswer;
    },
  },
  created() {},
  methods: {
    ...mapActions('prospectStore', [
      'createContactRating',
    ]),
    confirm(selectedAnswer) {
      this.selectedAnswer = selectedAnswer;

      const payload = {
        contactId: this.prospect.contact.id,
        prospectKey: this.prospect.key,
        ratingEntityTypeId: 1,
        score: this.selectedAnswer,
        agentId: this.agent && this.agent.id ? this.agent.id : null,
        userId: this.userid,
      };

      this.createContactRating(payload).then(() => {
        if (this.selectedAnswer < 3) {
          this.$emit('update-view', 'lowRatingReason');
        } else {
          this.$emit('update-view', 'contactedCallOutcome');
        }
      }).catch((error) => {
        this.disabledButtonClick = false;
        console.error(error);
      });

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
